import EntityListCard from '@/components/EntityListCard';
import BigVideoListCard from '@/components/BigVideoListCard';
import { CONTENT_TYPES } from '@/constants/generalConstants';
import React from 'react';
import MyLoader from '@/components/MyLoader';
import ArticleListCard from '@/components/ArticleListCard';
import MoreButton from '@/components/MoreButton';
import { ContentEntityListProps } from '@/components/containers/types';
import { dynamicClientRouteMaker } from '@/helpers/routes/dynamicClientRouteMaker';
import UserSubmissionsVideoCover from '@/app/(matches)/campaigns/[id]/ugc/components/UserSubmissionsVideoCover';
import { UGC_TYPES } from '@/constants/userGeneratedContentsConstants';
import { useRouter } from 'next/navigation';

export default function ContentEntityList({
    data: { content_type, section_type, cards, has_related_link, related_link, title } = {},
    moreButtonLink,
    className,
    cardClassName
}: ContentEntityListProps) {
    const router = useRouter();
    let CardComponent;
    let props = {
        isSingleBanner: false
    };

    switch (content_type?.toLowerCase()) {
        case CONTENT_TYPES.quiz:
        case 'banner': {
            if (section_type?.toLowerCase() === 'single') {
                props = { isSingleBanner: true };
            }
            CardComponent = BigVideoListCard;
            break;
        }
        case CONTENT_TYPES.articleModel:
        case CONTENT_TYPES.article: {
            CardComponent = ArticleListCard;
            break;
        }
        case CONTENT_TYPES.userCampaignMedia: {
            props = {
                isSingleBanner: false,
                hasTitle: true,
                containerClassName: 'max-w-[130px]'
            };
            CardComponent = UserSubmissionsVideoCover;
            break;
        }

        default: {
            CardComponent = EntityListCard;
            break;
        }
    }
    return (
        !!cards &&
        !!cards?.length && (
            <div
                className={`entity-list-outer-container content-page-entity-list-container ${className}`}>
                {(!props.isSingleBanner || has_related_link) && (
                    <div className="entity-list-header">
                        <h2 className="entity-list-title">{title}</h2>
                        {has_related_link && (
                            <MoreButton
                                descriptiveText={title}
                                to={
                                    moreButtonLink
                                        ? moreButtonLink
                                        : dynamicClientRouteMaker({
                                              id: related_link?.obj_id,
                                              type: related_link?.obj_type,
                                              url: related_link?.url,
                                              urlAlias: related_link?.url_alias
                                          })
                                }
                            />
                        )}
                    </div>
                )}
                <div className="entity-list-container hide-scroll">
                    {!cards ? (
                        <MyLoader width={40} className="list-loading" />
                    ) : !cards.length ? (
                        <p>موردی یافت نشد</p>
                    ) : (
                        CardComponent &&
                        cards?.map(
                            (
                                {
                                    title,
                                    media_object,
                                    multi_media_type,
                                    related_link,
                                    has_bookmarked,
                                    stream_log,
                                    id,
                                    season,
                                    season_id,
                                    series,
                                    number,
                                    thumbnail_image,
                                    alt_text,
                                    posters,
                                    special_name
                                },
                                index
                            ) => {
                                return (
                                    <CardComponent
                                        key={related_link?.obj_id || id || index}
                                        id={related_link?.obj_id || id}
                                        actionDestination={dynamicClientRouteMaker({
                                            id:
                                                related_link?.obj_id ||
                                                media_object?.related_link?.obj_id ||
                                                id,
                                            type:
                                                related_link?.obj_type ||
                                                media_object?.related_link?.obj_type ||
                                                CONTENT_TYPES.video,
                                            url:
                                                related_link?.url ||
                                                media_object?.related_link?.url,
                                            urlAlias:
                                                related_link?.url_alias ||
                                                media_object?.related_link?.url_alias,
                                            multimediaType:
                                                media_object?.multi_media_type || multi_media_type,
                                            moreData: {
                                                seriesId: series || media_object?.series,
                                                seasonId: season_id || media_object?.season_id
                                            }
                                        })}
                                        title={media_object?.title || title}
                                        tags={media_object?.tags || []}
                                        avatar={media_object?.avatar}
                                        pdpPoster={
                                            media_object?.posters?.pdp_poster ||
                                            posters?.pdp_poster ||
                                            media_object?.image ||
                                            media_object?.thumbnail_image ||
                                            thumbnail_image
                                        }
                                        verticalPoster={
                                            media_object?.posters?.vertical_poster ||
                                            posters?.vertical_poster ||
                                            media_object?.image ||
                                            media_object?.vertical_poster ||
                                            media_object?.thumbnail_image
                                        }
                                        horizontalPoster={
                                            media_object?.posters?.horizontal_poster ||
                                            posters?.horizontal_poster ||
                                            media_object?.image ||
                                            media_object?.thumbnail_image ||
                                            media_object?.background_image
                                        }
                                        cover={media_object?.file_cover}
                                        likeCount={media_object?.like_count}
                                        viewCount={media_object?.view_count}
                                        handleClick={() =>
                                            router.push(
                                                `/vertical-player-page/${CONTENT_TYPES.userCampaignMedia}/${media_object?.id}/${UGC_TYPES.campaignMedia}`
                                            )
                                        }
                                        isExclusive={media_object?.is_exclusive}
                                        isComingSoon={media_object?.is_coming_soon}
                                        alt={
                                            media_object?.alt_text ||
                                            media_object?.posters?.alt_text ||
                                            alt_text
                                        }
                                        className="entity-list-card"
                                        cardClassName={cardClassName}
                                        multimediaType={
                                            multi_media_type || media_object?.multi_media_type
                                        }
                                        seasonNumber={media_object?.season || season}
                                        episodeNumber={media_object?.number || number}
                                        specialName={media_object?.special_name || special_name}
                                        cardType={content_type?.toLowerCase()}
                                        isHorizontal={stream_log}
                                        streamLog={stream_log}
                                        hasBookmarked={has_bookmarked}
                                        {...props}
                                    />
                                );
                            }
                        )
                    )}
                </div>
            </div>
        )
    );
}
